import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('submit', '.discuss__form', (e) => {
    const $form = $(e.target);
    const isPrivateNote = $form.find('.discuss__kind').val() === 'private_note';
    const $message = $('#comment_body', $form);
    const comment = $message.val().replaceAll('<p><br></p>', '');
    $message.val(comment);
    if (isPrivateNote) {
      const $tiptapEditor = $form.find('.tiptap');
      const mentionedUserIds = $.map($tiptapEditor.find('[data-type="mention"]'), (el) => {
        return $(el).data('id');
      });

      $('#comment_user_ids', $form).val(mentionedUserIds);
    }
    const formData = new FormData(e.target);
    const $jsUploader = $form.find('.js-comment-uploader');
    const $submit = $('button[type=submit]', $form);
    const $discussion = $('.discuss__comments-container');
    const $fileUploadField = $form.find('.file-uploader-field');
    const imageElementName = $fileUploadField.attr('name');
    const imageFiles = $fileUploadField.data().files;

    formData.delete(imageElementName);

    for (const idx in imageFiles) {
      formData.append(imageElementName, imageFiles[idx], imageFiles[idx].name);
    }

    if ($('.uploader .loading').length) {
      alert('Please wait while all files finish uploading');
      return false;
    }

    // either a comment is present or some image has been added
    if ($message.val() || $jsUploader.find('input[name=item_ids]', $form).val()) {
      $submit.addClass('button-loading').prop('disabled', true);
      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
      }).done((data) => {
        $discussion.prepend(data);
        $form.find('.file-preview-link').remove();
        $jsUploader.hide().find('.uploader__thumbs').html('');
        $jsUploader.find('input[name=item_ids]').val('');
        $submit.removeClass('button-loading').prop('disabled', false);
        $fileUploadField.data('files', []);
      });
    }

    return false;
  });
});
